import HeroDual from './heroDual'

export default HeroDual
